module.exports = __webpack_public_path__ + "img/visionplus_icon.25119af9.svg";